import {HStack} from "@chakra-ui/layout";
import {ReactNode} from "react";
import {scrollbar} from "../styling";

export default function Page(props: {children: ReactNode}) {
    return <HStack
        w={"full"}
        pl={{base: 0, md: ".5rem"}}
        sx={scrollbar.hidden}
    >
        {props.children}
    </HStack>;
};
